// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__ydhDX","content":"Layout_content__eGuLx"};